import CryptoJS from "crypto-js";
import { DECRYPT_KEY } from "@/config";

function decryptString(key, encryptedText) {
  try {
    //@ts-ignore
    const iv = CryptoJS.lib.WordArray.create(16);
    const keyBytes = CryptoJS.SHA256(key);

    const decrypted = CryptoJS.AES.decrypt(
      // @ts-ignore
      {
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
      },
      keyBytes,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (ex) {
    // console.error(ex);
    return null;
  }
}

export const decryptInterceptor = (response) => {
  if (DECRYPT_KEY && response.data) {
    response.data = decryptString(DECRYPT_KEY, response.data);
  }
  return response;
};
